



















































































import {Vue, Component} from 'vue-property-decorator'
import {namespace} from 'vuex-class'

import {UpdateBankAccountPayload} from '@/store/modules/taxrefund/types'

import PagePopup from '@/components/popup/page/PagePopup.vue'
import PageHeader from '@/components/PageHeader.vue'
import PageFooter from '@/components/PageFooter.vue'
import LoadingComponent from '@/components/LoadingComponent.vue'

import BankModal from './BankModal.vue'
import BankConfirmModal from './BankConfirmModal.vue'
import ErrorModal from './ErrorModal.vue'

const taxrefund = namespace('taxrefund')
const biz = namespace('biz')

@Component({
  components: {
    PagePopup,
    PageHeader,
    PageFooter,
    BankModal,
    BankConfirmModal,
    ErrorModal,
    LoadingComponent,
  },
})
export default class InputBank extends Vue {
  @biz.State('id') bizId: string | null
  @taxrefund.State('id') taxRefundId: string | null
  @taxrefund.Action('getTaxRefund') getTaxRefund: () => Promise<void>
  @taxrefund.Action('updateBankAccount') updateBankAccount: (payload: UpdateBankAccountPayload) => Promise<void>

  isShowBankListModal: boolean = false
  isShowErrorModal: boolean = false
  isShowConfirmModal: boolean = false
  bankUserName: string = ''
  bankName: string = ''
  bankAccount: string = ''
  errorBankAccount: boolean = false
  errorLifeTimeBankAccount: boolean = false
  fetching: boolean = false

  async handleSubmit() {
    if(!this.taxRefundId) {
      const getTaxRefundEntity = this.getTaxRefund()
      await Promise.all([getTaxRefundEntity])
    }
    if(this.taxRefundId) {
      this.fetching = true
      this.updateBankAccount({
        taxRefundId: this.taxRefundId,
        bizId: this.bizId || '',
        bankName: this.bankName,
        bankOwnerName: this.bankUserName,
        bankAccountName: this.bankAccount,
      }).then(() => {
        this.$emit('next')
      }).catch(() => {
        this.isShowErrorModal = true
      }).finally(() => {
        this.fetching = false
      })
    } else {
      this.isShowErrorModal = true
    }
  }

  handleBankUserName(event: Event) {
    const targetEl = (event.target as HTMLInputElement)
    const targetValue = targetEl.value.replace(/[\\"']+/g, '').substring(0, 15)
    targetEl.value = targetValue
    this.bankUserName = targetValue
  }
  handleBankName() {
    this.isShowBankListModal = true
  }
  selectBankName(bankName: string) {
    this.bankName = bankName
    this.isShowBankListModal = false
  }
  handleBankAccount(event: Event) {
    const targetEl = (event.target as HTMLInputElement)
    // 최대 20개의 숫자까지 입력 가능, '-' 포함하면 최대 25자까지 입력 가능
    const endSize = targetEl.value.includes('-') ? 25 : 20
    const targetValue = targetEl.value.replace(/[^0-9-]+/g, '').substring(0, endSize)
    // validBankAccount(targetValue)
    targetEl.value = targetValue
    this.bankAccount = targetValue
  }
  validBankAccount(target: string) {
    // 최대 14개의 숫자까지 제출 가능, '-' 포함하면 최대 20까지 제출 가능
    const onlyNumber = target.replace(/-/g, '') 
    if(onlyNumber.length > 14) {
      this.errorBankAccount = true
      return false
    }
    if(target.length > 20) {
      this.errorBankAccount = true
      return false
    }
    if(target[0] === '-' || target[target.length -1] === '-' || target.includes('--')) {
      this.errorBankAccount = true
      return false
    }
    if(target.length === 11 && (target.slice(0, 3) === '010' || target.slice(0, 4) === '0010')) {
      this.errorBankAccount = true
      this.errorLifeTimeBankAccount = true
      return false
    } 
    this.errorLifeTimeBankAccount = false
    this.errorBankAccount = false
    return true
  }
  isDisabled() {
    const onlyNumberForBankAccount = this.bankAccount.replace(/-/g, '') 
    return !this.bankUserName || !this.bankName || onlyNumberForBankAccount.length < 10 || this.errorBankAccount
  }
  handleConfirm() {
    this.isShowConfirmModal = true
  }
}
